import { render } from "./HomeView.vue?vue&type=template&id=53db35d5&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import "./HomeView.vue?vue&type=style&index=0&id=53db35d5&lang=stylus"

import exportComponent from "E:\\Web\\Vue3\\TypeScript\\wallpaper\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__